import { useState, useEffect } from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";
import { Info } from "lucide-react";
import { Dialog, DialogContent, DialogTrigger } from "./ui/dialog";
import { Button } from "./ui/button";

export default function TooltipInfo({helpText}) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  return isMobile ? (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="text">
          <Info className="size-4 text-zinc-400" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <p>{helpText}</p>
      </DialogContent>
    </Dialog>
  ) : (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button variant="text">
            <Info className="size-4 text-zinc-400" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{helpText}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
